<template>
  <el-button :type="type" :style="{'width': width}" :loading="loading" @click="doClick">{{getText}}</el-button>
</template>

<script>
  export default{
    props:{
      type:{
        type:String,
        default:'primary'
      },
      width:{
        type:String,
        default:"150px"
      },
      name:{
        type:String,
        default:'保 存'
      },
      loadingName:{
        type:String,
        default:'保存中'
      },
      loading:{
        type:Boolean,
        default:false
      }
    },
    watch:{
    },
    computed:{
      getText(){
        if(this.isLoading){
          return this.loadingName
        }else{
          return this.name
        }
      }
    },
    mounted() {
    },
    data(){
      return{
      }
    },
    methods:{
      doClick(){
        this.$emit("click")
      }
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/basic/FwSaveButton.vue